import { render } from "./vyingbipresentinfo.vue?vue&type=template&id=210b3458&scoped=true"
import script from "./vyingbipresentinfo.vue?vue&type=script&lang=js"
export * from "./vyingbipresentinfo.vue?vue&type=script&lang=js"

import "./vyingbipresentinfo.vue?vue&type=style&index=0&id=210b3458&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210b3458"]])

export default __exports__